export default __webpack_public_path__ + "static/media/entry.f9229f67.png";